import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormGroup = () => (
  <ComponentDocs
    name="<Form.Group/>"
    entry="GroupField"
    propsEntry="GroupFieldProps"
    namespace="FormCollections"
  >
    <ComponentExample
      name="Grouping fields"
      import={import("examples/Forms/FormGroup/FormGroupExample")}
      rawImport={import("examples/Forms/FormGroup/FormGroupExample?raw")}
    />
    <ComponentExample
      name="Nested groups"
      import={import("examples/Forms/FormGroup/NestedGroupsExample")}
      rawImport={import("examples/Forms/FormGroup/NestedGroupsExample?raw")}
    />
    <ComponentExample
      name="Custom content / vertical alignment"
      import={import("examples/Forms/FormGroup/VerticalAlignmentExample")}
      rawImport={import(
        "examples/Forms/FormGroup/VerticalAlignmentExample?raw"
      )}
    />
    <ComponentExample
      name="Undefined columns"
      description="When the columns prop is not specified, fields will assume their own widths."
      import={import("examples/Forms/FormGroup/UndefinedColumnsExample")}
      rawImport={import("examples/Forms/FormGroup/UndefinedColumnsExample?raw")}
    />
  </ComponentDocs>
);

export default FormGroup;
